<div class="dialog-container">
	<div class="dialog-header">
		<h2 mat-dialog-title>
			<mat-icon>add_circle</mat-icon>
			<span>Add {{ data.fieldTypeLabel }} Field</span>
		</h2>
		<button mat-icon-button (click)="onCancel()" class="close-button">
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<mat-dialog-content>
		<form [formGroup]="fieldForm" class="field-form">
			<p class="help-text">
				<strong>Required fields are marked with *</strong><br />
				These properties can be changed later in the properties panel.
			</p>

			<div class="required-section">
				<h4 class="section-title">Required Properties</h4>

				<mat-form-field appearance="outline" class="formly-full-width">
					<mat-label>Field Key</mat-label>
					<input matInput formControlName="key" placeholder="e.g., firstName" required />
					<mat-hint>Unique identifier used in the data model</mat-hint>
					<mat-error *ngIf="keyControl?.invalid">{{ keyErrorMessage }}</mat-error>
				</mat-form-field>

				<mat-form-field appearance="outline" class="formly-full-width">
					<mat-label>Field Label</mat-label>
					<input matInput formControlName="label" placeholder="e.g., First Name" required />
					<mat-hint>Display label shown to users</mat-hint>
					<mat-error *ngIf="labelControl?.invalid">{{ labelErrorMessage }}</mat-error>
				</mat-form-field>
			</div>

			<div class="optional-section">
				<h4 class="section-title">Optional Properties</h4>

				<mat-form-field appearance="outline" class="formly-full-width">
					<mat-label>Placeholder</mat-label>
					<input matInput formControlName="placeholder" placeholder="e.g., Enter your first name" />
					<mat-hint>Placeholder text for input fields</mat-hint>
				</mat-form-field>

				<mat-form-field appearance="outline" class="formly-full-width">
					<mat-label>Description</mat-label>
					<textarea
						matInput
						formControlName="description"
						rows="2"
						placeholder="e.g., Enter your legal first name"
					></textarea>
					<mat-hint>Help text or description for the field</mat-hint>
				</mat-form-field>

				<div class="checkbox-options">
					<mat-checkbox formControlName="required">Mark as required field</mat-checkbox>
					<mat-checkbox formControlName="disabled">Mark as disabled</mat-checkbox>
				</div>
			</div>
		</form>
	</mat-dialog-content>

	<mat-dialog-actions align="end">
		<button mat-button (click)="onCancel()">Cancel</button>
		<button mat-raised-button color="primary" (click)="onAdd()" [disabled]="fieldForm.invalid">
			<mat-icon>add</mat-icon>
			Add Field
		</button>
	</mat-dialog-actions>
</div>
